import { ExclamationCircleIcon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";
import useModalState from "@logics/hooks/useModalState";
import { useAuthSession } from "@domains/auth/hooks/useAuthSession";
import { RequestCreateServiceReport } from "@models/data-contracts";
import { useCreateReportMutation } from "@domains/common/networks/service/serviceMutations";
import { ToastError, ToastSuccess } from "@logics/utils/toast";
import {
  ERROR_MESSAGE,
  SERVICE_MESSAGE,
} from "@domains/common/constants/toastMessages";

import ReportForm from "./ReportForm/ReportForm";

import * as S from "./ReportMenu.style";

type ReportMenuProps = Omit<RequestCreateServiceReport, "content">;

const ReportMenu = ({ type, targetId }: ReportMenuProps) => {
  const { user } = useAuthSession();
  const { openModal } = useModalState();

  const reportMutation = useCreateReportMutation();

  // REPORT HANDLER
  const handleReportTarget = async (content: string) => {
    if (!targetId) return;

    try {
      await reportMutation.mutateAsync({
        type,
        targetId,
        content,
      });

      ToastSuccess(SERVICE_MESSAGE.REPORT_SUCCESS);
    } catch (error) {
      ToastError(ERROR_MESSAGE.SERVER_ERROR);
    }
  };

  // OPEN REPORT FORM
  const handleClickReportMenu = () => {
    if (!user?.id) return;

    openModal({
      CustomComponent: (
        <ReportForm
          type={type}
          onSubmitReport={(content) => handleReportTarget(content)}
        />
      ),
    });
  };

  return (
    <S.MenuList role="button" onClick={handleClickReportMenu}>
      <ExclamationCircleIcon strokeColor={grayScale.white} />
      <span>Report {type.toLowerCase()}</span>
    </S.MenuList>
  );
};

export default ReportMenu;
